import { z } from "zod";
import { TIME_WINDOW_DEFAULT } from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.constants";
import { array, number } from "src/utils/schema";

// Flat schema for URL parsing (unchanged external API)
export const URL_SCHEMA = z.object({
  timeWindow: z.string().optional(),
  appOwners: array(number).optional(),
  appTags: array(number).optional(),
});

export type URL_SCHEMA_TYPE = z.infer<typeof URL_SCHEMA>;

// Legacy flat schema (kept for URL parsing compatibility)
export const ZUSTAND_SCHEMA = z.object({
  state: URL_SCHEMA,
});

// New nested schema for per-env storage in sessionStorage/localStorage
export const ENV_STORAGE_SCHEMA = z.record(z.string(), URL_SCHEMA);
export type ENV_STORAGE_TYPE = z.infer<typeof ENV_STORAGE_SCHEMA>;

export const ZUSTAND_ENV_STORAGE_SCHEMA = z.object({
  state: ENV_STORAGE_SCHEMA,
});

export const TIME_WINDOW_KEY = "timeWindow";
export const STORAGE_KEY = "URL_AND_SESSION_STORAGE";
export const INITIAL_TIME_WINDOW = TIME_WINDOW_DEFAULT;
/**
 * Persist versions are split per store on purpose: they used to share one const,
 * so bumping this store's version also dropped the `global-context` slice
 * (zustand persist has no migrate) — including the timezone this filter needs.
 */
export const SEARCH_STORAGE_VERSION = 2;
export const GLOBAL_CONTEXT_VERSION = 1;

export const INITIAL_SESSION_STATE: URL_SCHEMA_TYPE = {
  [TIME_WINDOW_KEY]: INITIAL_TIME_WINDOW,
  appOwners: [],
  appTags: [],
};
